module.exports = __webpack_public_path__ + "img/brand-text-logo.f6eb73e8.svg";